/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n() {
  var n = new Float32Array(6);
  return n[0] = 1, n[3] = 1, n;
}

function t(n) {
  var t = new Float32Array(6);
  return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t;
}

function r(n, t, r, o, a, e) {
  var c = new Float32Array(6);
  return c[0] = n, c[1] = t, c[2] = r, c[3] = o, c[4] = a, c[5] = e, c;
}

function o(n, t) {
  return new Float32Array(n, t, 6);
}

function a(n, t, r, o) {
  var a = t[o],
      e = t[o + 1];
  n[o] = r[0] * a + r[2] * e + r[4], n[o + 1] = r[1] * a + r[3] * e + r[5];
}

function e(n, t, r) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var e = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var c = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2;
  var s = e || t.length / c;

  for (var f = o; f < s; f++) {
    a(n, t, r, f * c);
  }
}

var c = Object.freeze({
  __proto__: null,
  create: n,
  clone: t,
  fromValues: r,
  createView: o,
  transform: a,
  transformMany: e
});
export { t as a, o as b, n as c, a as d, r as f, c as m, e as t };